<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'メンバーを招待する'">
        <template slot="content">
          <div class="text">
            管理者は、<b>グループの名称／ID／グループQRコード</b>をメンバーに通知し、または「メニュー＞グループ管理＞友達を招待」でメンバーを招待することができます。<br><br>
            メンバーは、「メニュー＞グループに参加」で、企業やグループ名またはIDで検索して参加するか、グループQRコードをスキャンしてグループに参加します。
          </div>
          <img class="picture" src="../assets/images/features_admin/2.png">
          <img class="picture" src="../assets/images/features_admin/3.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesAdminMemberJoin.vue